function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import StoreContext from "@/context/root-store";
import AuthMenuComponent from "widget/AuthMenu";
import SpinnerCustomComponent from "widget/SpinnerCustom";
import { LeftMenu as LeftMenuComponent, Messages as MessagesComponent, SimpleHeader as SimpleHeaderComponent } from "@sogei/react-web-components-catalog";
// import headerLogo from '@sogei/react-web-components-catalog/dist/img/AgenziaDoganeMonopoli_logo_152.png'
import headerLogo from "../img/logo@2x.png";
import hintLogo from "../img/hintLogo.png";
import footerLogo from "@sogei/react-web-components-catalog/dist/img/AgenziaDoganeMonopoli_mono_152.png";
import img1 from '../img/Immagini_sito/IMG1.png';
import img2 from '../img/Immagini_sito/IMG2.png';
import img3 from '../img/Immagini_sito/IMG3.png';
var organization = {
  url: process.env.REACT_APP_LINK_ADM_HOME,
  name: "Presidenza del consiglio dei Ministri"
};
var buttonList = [{
  url: process.env.REACT_APP_LINK_ADM_HOME,
  icon: "fas fa-sign-out-alt fa-rotate-270",
  title: "Agenzia delle dogane e monopoli"
}];
var title = "CERTIFICAZIONE DELLA PARITÀ DI GENERE";
var subtitle = "";
var hint1 = "Presidenza del Consiglio dei Ministri";
var hint2 = "Dipartimento per le Pari Opportunità";
var hintFooter = "Certificazione della parità di genere";
var $ = require("jquery");
var AuthHeader = observer(function () {
  var _useState = useState("ITA"),
    _useState2 = _slicedToArray(_useState, 2),
    linguaState = _useState2[0],
    setLinguaState = _useState2[1];
  console.log();
  var data = {
    title: title,
    subtitle: subtitle,
    hint1: hint1,
    hint2: hint2,
    headerLogo: headerLogo,
    hintLogo: hintLogo,
    footerLogo: footerLogo,
    organization: organization,
    buttonList: buttonList
  };
  var lingua = sessionStorage.getItem("lingua");
  var setLingua = function setLingua(lingua) {
    sessionStorage.setItem("lingua", lingua);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    "aria-label": "Funzioni di servizio"
  }, /*#__PURE__*/React.createElement("div", {
    id: "agenzia-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col d-none d-md-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.hintLogo,
    alt: "",
    className: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("p", {
    className: "my-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.governo.it/",
    target: "_blank"
  }, data.hint1))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("p", {
    className: "my-1"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.pariopportunita.gov.it/",
    target: "_blank"
  }, data.hint2))))), /*#__PURE__*/React.createElement("div", {
    className: "col col-md-auto text-right"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Lingue disponibili:"), /*#__PURE__*/React.createElement("ul", {
    className: "list-inline language"
  }, /*#__PURE__*/React.createElement("li", {
    id: "ita",
    className: lingua === "ita" || lingua === null ? "list-inline-item active" : "list-inline-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: process.env.CONTEXT_PATH + "/home",
    className: "btn",
    onClick: function onClick() {
      return setLingua("ita");
    }
  }, "ITA", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, " ", "italiano"))), /*#__PURE__*/React.createElement("li", {
    id: "eng",
    className: lingua === "eng" ? "list-inline-item active" : "list-inline-item"
  }, /*#__PURE__*/React.createElement("a", {
    lang: "en",
    href: process.env.CONTEXT_PATH + "/info",
    className: "btn",
    onClick: function onClick() {
      return setLingua("eng");
    }
  }, "ENG", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, " ", "english")))))))), /*#__PURE__*/React.createElement("div", {
    id: "page-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("a", {
    href: process.env.CONTEXT_PATH + "/home"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.headerLogo,
    alt: "Home del sito Certificazione della parit\xE0 di genere",
    className: "logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col",
    id: "headerTitle"
  }, /*#__PURE__*/React.createElement("h1", null, data.title, /*#__PURE__*/React.createElement("small", {
    className: "mt-md-1"
  }, data.subtitle))))))));
});
var AuthFooter = observer(function () {
  var infos = [{
    label: "Dichiarazione di accessibilità",
    href: process.env.REACT_APP_LINK_ACCESSIBILITA
  }, {
    label: "Privacy policy",
    href: process.env.CONTEXT_PATH + process.env.REACT_APP_LINK_PRIVACY
  },
  // {
  //   label: "Preferenze cookie",
  //   href: process.env.CONTEXT_PATH + process.env.REACT_APP_LINK_NOTE_LEGALI
  // },
  {
    label: "Amministrazione trasparente",
    href: process.env.REACT_APP_LINK_AMMINISTRAZIONE_TRASPARENTE
  }];
  var socialInfo = [{
    label: "Facebook",
    url: process.env.REACT_APP_LINK_FACEBOOK,
    icon: "fab fa-facebook-f"
  }, {
    label: "Twitter",
    url: process.env.REACT_APP_LINK_TWITTER,
    icon: "fab fa-twitter"
  }, {
    label: "YouTube",
    url: process.env.REACT_APP_LINK_YOUTUBE,
    icon: "fab fa-youtube"
  }, {
    label: "Linkedin",
    url: process.env.REACT_APP_LINK_LINKEDIN,
    icon: "fab fa-linkedin"
  }, {
    label: "Instagram",
    url: process.env.REACT_APP_LINK_INSTAGRAM,
    icon: "fab fa-instagram"
  }];
  // {process.env.REACT_APP_LINK_CONTATTI}
  // const organization = {
  //   // name: "Amministrazione trasparente",
  //   // url: process.env.REACT_APP_LINK_AMMINISTRAZIONE_TRASPARENTE,
  //   address: "Presidenza del Consiglio dei ministri – Dipartimento per le pari opportunità – Largo Chigi,19 - Roma"
  // }

  var data = {
    title: title,
    subtitle: subtitle,
    hint: hintFooter,
    footerLogo: headerLogo,
    infos: infos,
    socialInfo: socialInfo,
    organization: organization
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", {
    id: "page-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-3 py-md-3 bgColorBlue"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row p-0 m-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("img", {
    src: img1,
    alt: "",
    className: "img-fluid mt-3 float-right"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col border-left border-right"
  }, /*#__PURE__*/React.createElement("img", {
    src: img2,
    alt: "",
    className: "img-fluid mt-3 mx-auto d-block"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("img", {
    src: img3,
    alt: "",
    className: "img-fluid mt-3 float-left"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.footerLogo,
    alt: "",
    className: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Informazioni su", " "), data.title))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-10"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm"
  }, /*#__PURE__*/React.createElement("b", null, data.hint, ":", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "text-white"
  }, "Presidenza del Consiglio dei ministri \u2013 ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.pariopportunita.gov.it/",
    target: "_blank"
  }, "Dipartimento per le pari opportunit\xE0"), " ", /*#__PURE__*/React.createElement("br", null), "  Largo Chigi, 19 - Roma"))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm"
  }, /*#__PURE__*/React.createElement("b", null, "Contatti:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "mailto:certificazione.pariopportunita@governo.it"
  }, "certificazione.pariopportunita@governo.it")))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", {
    className: "sr-only"
  }, "Altre informazioni"), /*#__PURE__*/React.createElement("ul", {
    className: "list-inline mr-3 text-center"
  }, data.infos.map(function (info) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "list-inline-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: info.href,
      target: "_black"
    }, info.label)));
  })))))));
});
var AuthMenu = observer(function () {
  var rootStore = React.useContext(StoreContext).rootStore;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    listprogettiApprovazione = _useState4[0],
    setListProgettiApprovazione = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    listprogettiSalvati = _useState6[0],
    setListProgettiSalvati = _useState6[1];
  // const userInfos: any = rootStore.userInfoStore.userInfos;

  // TODO: distinguere la chiamata in base al profilo quando sarà disponibile
  useEffect(function () {
    // rootStore.uiStore.clearMessages()
  }, []);
  var data = {
    // userInfo: userInfos.role,
    nProgettiSalvati: listprogettiSalvati.length > 0 ? listprogettiSalvati.length : 0,
    nProgettiApprovazione: listprogettiApprovazione.length > 0 ? listprogettiApprovazione.length : 0
  };
  return /*#__PURE__*/React.createElement(AuthMenuComponent, data);
});
var Messages = observer(function (_ref) {
  var extraClass = _ref.extraClass;
  var rootStore = React.useContext(StoreContext).rootStore;
  var data = {
    successMessages: rootStore.uiStore.successMessages,
    infoMessages: rootStore.uiStore.infoMessages,
    warningMessages: rootStore.uiStore.warningMessages,
    dangerMessages: rootStore.uiStore.dangerMessages,
    messagesCount: rootStore.uiStore.messagesCount
  };
  return /*#__PURE__*/React.createElement(MessagesComponent, _extends({}, data, {
    extraClass: extraClass
  }));
});

// const Spinner = observer(() => {
//     const rootStore = React.useContext<StoreContextProps>(StoreContext)
//         .rootStore
//     const data = {
//         isLoading: rootStore.uiStore.isLoading
//     }
//     return <SpinnerComponent {...data}></SpinnerComponent>
// })

var SpinnerCustom = observer(function () {
  var rootStore = React.useContext(StoreContext).rootStore;
  var data = {
    isLoading: rootStore.uiStore.isLoading
  };
  return /*#__PURE__*/React.createElement(SpinnerCustomComponent, data);
});
var LeftMenu = observer(function () {
  var rootStore = React.useContext(StoreContext).rootStore;
  var data = {
    context: process.env.CONTEXT_PATH,
    // leftMenuItems: rootStore.menuStore.leftMenuItems,
    // label: rootStore.menuStore.label,
    location: rootStore.routingStore.location
  };
  return /*#__PURE__*/React.createElement(LeftMenuComponent, data);
});
var SimpleHeader = observer(function () {
  var data = {
    logo: footerLogo,
    title: title,
    subtitle: subtitle
  };
  return /*#__PURE__*/React.createElement(SimpleHeaderComponent, data);
});
var SimpleFooter = observer(function () {
  var data = {
    logo: footerLogo,
    title: title,
    subtitle: subtitle
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", {
    id: "page-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-3 py-md-3 bgColorBlue"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row gx-2 gx-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("img", {
    src: img1,
    alt: "",
    className: "img-fluid mt-3 float-right"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col border-left border-right"
  }, /*#__PURE__*/React.createElement("img", {
    src: img2,
    alt: "",
    className: "img-fluid mt-3 mx-auto d-block"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("img", {
    src: img3,
    alt: "",
    className: "img-fluid mt-3 float-left"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: "resources/img/*_mono_152.png",
    alt: "",
    className: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Informazioni su", " "), "Denominazione sito"))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-8"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm"
  }, /*#__PURE__*/React.createElement("b", null, "Certificazione della parit\xE0 di genere:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "text-white"
  }, "Indirizzo"))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm "
  }, /*#__PURE__*/React.createElement("b", null, "Contatti:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "mailto:"
  }, "certificazione.paritadigenere@governo.it ")))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("h3", {
    className: "sr-only"
  }, "Altre informazioni"), /*#__PURE__*/React.createElement("ul", {
    className: "list-inline mr-3"
  }, /*#__PURE__*/React.createElement("li", {
    className: "list-inline-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: ""
  }, "Dichiarazione di accessibilit\xE0")), /*#__PURE__*/React.createElement("li", {
    className: "list-inline-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: ""
  }, "Privacy policy"))), "Nome amministrazione afferente")))));
});
export { AuthHeader, SimpleHeader, SimpleFooter, AuthFooter, AuthMenu, LeftMenu, Messages, SpinnerCustom };